import { DiagnosisType } from "@core/domain/models/diagnosis-type.model";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";
import { BeneficiaryRepository } from "../../data/repositories/beneficiary.repository";

@injectable()
export class GetAllDiagnosisTypesUseCase {
    constructor(
        @inject(BeneficiaryRepository)
        private readonly beneficiaryRepository: BeneficiaryRepository,
    ) {}

    async execute(): Promise<DiagnosisType[]> {
        const diagnosisTypesResult =
            await this.beneficiaryRepository.getAllDiagnosisTypes();

        if (diagnosisTypesResult.isLeft()) {
            ToastManagerStore.error(
                diagnosisTypesResult.getLeftOrThrow().message,
            );
        }

        return diagnosisTypesResult.fold(
            () => [],
            (diagnosisTypes) => diagnosisTypes,
        );
    }
}
